import { PromotionContent } from '@core/models/promotion-content.model';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';

@Injectable()
export class PromotionContentEntityService extends EntityCollectionServiceBase<PromotionContent> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
      super('PromotionContent', serviceElementsFactory);
  }
}
